export default __webpack_public_path__ + "static/media/skola-banner-secondary-mobile.33f54096.png";